import type { EditorStarterItem } from '../items/item-type';
import { getCropFromItem } from '../utils/get-crop-from-item';

export interface VisibleRect {
  width: number;
  height: number;
  left: number;
  top: number;
}

export const resizeVisibleRectToItem = (
  target: EditorStarterItem,
  rect: VisibleRect,
): EditorStarterItem => {
  const crop = getCropFromItem(target);
  const cropLeft = crop?.cropLeft ?? 0;
  const cropTop = crop?.cropTop ?? 0;
  const cropRight = crop?.cropRight ?? 0;
  const cropBottom = crop?.cropBottom ?? 0;
  const cropWidth = 1 - cropLeft - cropRight;
  const cropHeight = 1 - cropTop - cropBottom;

  const width = Math.max(1, Math.round(rect.width / cropWidth));
  const height = Math.max(1, Math.round(rect.height / cropHeight));
  const left = Math.round(rect.left - width * cropLeft);
  const top = Math.round(rect.top - height * cropTop);

  return {
    ...target,
    width,
    height,
    left,
    top,
  } as EditorStarterItem;
};
